import unescapedText from 'I18n/utils/unescapedText';
import { AllProductsCard } from '../../components/AllProductsCard';
import { jsx as _jsx } from "react/jsx-runtime";
export function AllSection({
  productType,
  sectionIndex
}) {
  // Use the AllProductsCard for better discoverability
  const sectionType = productType === 'APP' ? 'ALL_APPS' : 'ALL_AGENTS';
  const seeMoreHref = `/explore?eco_PRODUCT_TYPE=${String(productType)}`;
  const seeMoreText = productType === 'APP' ? unescapedText('marketplaceStorefront.sliderSection.allApps') : unescapedText('marketplaceStorefront.sliderSection.allAgents');
  return /*#__PURE__*/_jsx(AllProductsCard, {
    seeMoreHref: seeMoreHref,
    seeMoreText: seeMoreText,
    sectionIndex: sectionIndex,
    sectionType: sectionType,
    subscreen: `all ${productType.toLowerCase()}s section`
  });
}